import { create } from 'zustand'

export type SurveyStep =
  | 'introduction'
  | 'recarding-preference-question'
  | 'success'

interface State {
  step: SurveyStep
  recardingPreferenceAnswer?: Enum.CorporateSurveyRecardingPreferenceResponse
}

interface Methods {
  setStep: (step: SurveyStep) => void
  setRecardingPreferenceAnswer: (
    anwswer: Enum.CorporateSurveyRecardingPreferenceResponse
  ) => void
}

const initialState: State = {
  step: 'introduction'
}

export const useRecardingPreferenceSurveyStore = create<State & Methods>(
  (set) => ({
    ...initialState,
    setStep: (step) => set({ step }),
    setRecardingPreferenceAnswer: (
      answer: Enum.CorporateSurveyRecardingPreferenceResponse
    ) => set({ recardingPreferenceAnswer: answer })
  })
)
